import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HistoryRoundList} from "./model/round-history";

@Injectable({
    providedIn: 'root'
})
export class RoundHistoryService {

    constructor(private httpClient: HttpClient) {

    }

    getRoundHistory(): Observable<HistoryRoundList> {
        return this.httpClient.get<HistoryRoundList>('/rest/rounds', {withCredentials: true});
    }
}
